import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Tells the Hotwire Native app how deep the chat is in its own panels
// (0 list, 1 conversation, 2 details, 3 media). The app disables its edge
// swipe-back while a panel is open, so the web's swipe (swipe_back_controller)
// can close the panel instead of the app popping the whole chat screen.
//
// Registered as `chat-navigation`; the chat UI dispatches
// `bryght-chat:navigation-depth` on this element after each change. Without
// the app (browser, or an app that does not know the component) `send` is a
// no-op.
export default class extends BridgeComponent {
  static component = "chat-navigation"

  connect() {
    super.connect()
    // `connect` runs again on native:restore; one listener is enough.
    this._onDepth ??= (e) => this.send("depth", { depth: e.detail?.depth ?? 0 })
    this.element.removeEventListener("bryght-chat:navigation-depth", this._onDepth)
    this.element.addEventListener("bryght-chat:navigation-depth", this._onDepth)
    // The UI may already be open when this controller connects or restores.
    this.send("depth", { depth: Number(this.element.dataset.chatNavigationDepth || 0) })
  }

  disconnect() {
    this.element.removeEventListener("bryght-chat:navigation-depth", this._onDepth)
    super.disconnect()
  }
}
